import { render, staticRenderFns } from "./createOrUpdateAdvertising.vue?vue&type=template&id=e2dd925e"
import script from "./createOrUpdateAdvertising.vue?vue&type=script&lang=js"
export * from "./createOrUpdateAdvertising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports